import { LockClosedIcon, SparklesIcon } from '@heroicons/react/24/solid'
import PropTypes from 'prop-types'

import { CHAT, MATCH_SCORE } from '../content'
import { anim, prog } from '../motion'
import { Avatar, Box, Typed } from '../primitives'

// Schritte: 0 Warum 64 %? · 1 Interviewfragen · 2 Tipp und klare Grenze
export default function SceneAssistant() {
  return (
    <Box
      x={150}
      y={30}
      w={660}
      h={580}
      className='sty-card sty-chat'
      style={anim({ at: [0.01, 0.1], y: 30 })}
    >
      <div className='sty-chat__head'>
        <span className='sty-chat__logo'>
          <SparklesIcon width={20} height={20} color='#fff' />
        </span>
        <div>
          <div className='sty-strong'>Aivy Assistent</div>
          <div className='sty-muted sty-small'>
            Fragen zum Passungsprofil von Lena K.
          </div>
        </div>
        <span className='sty-badge' style={{ marginLeft: 'auto' }}>
          Hilfsmittel
        </span>
      </div>

      <div className='sty-chat__body'>
        <div
          className='sty-abs sty-chat__list'
          style={{
            ...prog([0.67, 0.73]),
            transform: 'translateY(calc(var(--p) * -170px))'
          }}
        >
          <Bubble me top={20} at={[0.01, 0.05]}>
            {CHAT.q1}
          </Bubble>
          <Dots top={84} at={[0.05, 0.07]} out={[0.09, 0.1]} />
          <Bubble top={84} at={[0.09, 0.11]}>
            <Typed text={CHAT.a1} at={[0.1, 0.22]} />
          </Bubble>

          <Bubble me top={226} at={[0.35, 0.39]}>
            {CHAT.q2}
          </Bubble>
          <Dots top={290} at={[0.39, 0.41]} out={[0.43, 0.44]} />
          <Bubble top={290} at={[0.43, 0.45]}>
            <div className='sty-strong'>Zwei Fragen für das Gespräch</div>
            <ol className='sty-chat__ol'>
              {CHAT.a2.map((q, i) => (
                <li key={q}>
                  <Typed text={q} at={[0.45 + i * 0.05, 0.5 + i * 0.05]} />
                </li>
              ))}
            </ol>
          </Bubble>

          <Bubble top={460} at={[0.7, 0.74]} tone='tip'>
            <Typed text={CHAT.tip} at={[0.72, 0.82]} />
          </Bubble>
        </div>
      </div>

      <div className='sty-chat__lock' style={anim({ at: [0.79, 0.85], y: 20 })}>
        <LockClosedIcon width={16} height={16} />
        <span>
          Passung {MATCH_SCORE}&nbsp;% bleibt regelbasiert berechnet. Die KI
          erklärt nur.
        </span>
      </div>
    </Box>
  )
}

function Bubble({ me, top, at, tone, children }) {
  return (
    <div
      className={
        me
          ? 'sty-bubble sty-bubble--me'
          : tone === 'tip'
            ? 'sty-bubble sty-bubble--tip'
            : 'sty-bubble'
      }
      style={{ top, ...anim({ at, x: me ? 20 : -20, y: 10 }) }}
    >
      {me && (
        <Avatar
          initials='M'
          color='blue'
          size={26}
          className='sty-bubble__avatar'
        />
      )}
      {children}
    </div>
  )
}

function Dots({ top, at, out }) {
  return (
    <div
      className='sty-bubble sty-typing'
      style={{ top, ...anim({ at, out, y: 6, oy: 0 }) }}
    >
      <i />
      <i />
      <i />
    </div>
  )
}

const range = PropTypes.arrayOf(PropTypes.number)

Bubble.propTypes = {
  me: PropTypes.bool,
  top: PropTypes.number.isRequired,
  at: range.isRequired,
  tone: PropTypes.oneOf(['tip']),
  children: PropTypes.node
}

Dots.propTypes = {
  top: PropTypes.number.isRequired,
  at: range.isRequired,
  out: range.isRequired
}
